import PropTypes from "prop-types";
import classNames from "classnames";
import classes from "./RadioCircle.module.css";

const RadioCircle = (props) => {
  const { className, checked } = props;
  return (
    <div
      className={classNames(
        classes["radio-circle"],
        {
          [classes["radio-circle--checked"]]: checked,
        },
        className
      )}
    />
  );
};

export default RadioCircle;

RadioCircle.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
};
